import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: any, pattern: string = 'mediumDate'): string {
        const date = new Date(value);
        const dateWithTimezoneOffset = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000 || '');
        const datePipe: DatePipe = new DatePipe(`${this.translate.currentLang}-CA`);
        return datePipe.transform(dateWithTimezoneOffset, pattern);
    }
}
